/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedule_Create_SuccessInputs */



/**
* | output |
* | --- |
* | "Schedule saved." |
*
* @param {Agent_Schedule_Create_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_create_success = /** @type {((inputs?: Agent_Schedule_Create_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Create_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitplan gespeichert.")
	return /** @type {LocalizedString} */ ("Schedule saved.")
});